import config from 'common/config'
import Constants from 'common/constants'
import Http from 'common/http'

export interface TenantPublicInterface {
  id: string
  slug: string
  name: string
  status: string
  /**
   * PENDING | READY | FAILED — se o subdominio desta imobiliaria ja foi
   * provisionado (CNAME + alias). Enquanto nao for READY, qualquer navegação
   * deve usar o endereço de caminho — ver `tenantUrlWithFallback`.
   */
  dnsStatus: string
  /**
   * `www.dominio-do-cliente`, so quando o dominio proprio ja esta READY
   * (Feature #538). Nulo nos demais casos.
   */
  customDomain?: string | null
}

export interface TenantMeInterface extends TenantPublicInterface {
  plan: string
  trialEndsAt: string | null
  trialDaysLeft: number | null
  /** A imobiliaria original mora na raiz do dominio, sem prefixo na URL. */
  defaultTenant: boolean
  /** PENDING | READY | DISABLED — o `/me` mostra o dominio mesmo antes de READY. */
  customDomainStatus?: string | null
}

const basePath = `${config.API_URL}/${Constants.API_URl_PREFIX}/tenant`

const TenantService = {
  /**
   * Resolve a imobiliaria pelo slug da URL.
   *
   * Nao usa o cliente HTTP comum de proposito: este e o passo que decide se o
   * slug existe, e o cliente comum envia o proprio slug no header — o que faria
   * a chamada falhar antes de chegar ao controller quando o slug e invalido.
   */
  findBySlug: async (slug: string): Promise<TenantPublicInterface | null> => {
    const response = await fetch(
      `${basePath}/by-slug/${encodeURIComponent(slug)}`
    )
    if (!response.ok) return null
    return response.json()
  },

  /**
   * Imobiliaria dona de um dominio proprio (Feature #538). Pelo mesmo motivo
   * do `findBySlug`, nao usa o cliente HTTP comum: e chamado antes de existir
   * slug para mandar no header.
   *
   * Devolve `null` para 404 e lanca em falha de rede — o bootstrap mostra
   * telas diferentes para os dois casos.
   */
  findByHost: async (host: string): Promise<TenantPublicInterface | null> => {
    const response = await fetch(
      `${basePath}/by-host/${encodeURIComponent(host)}`
    )
    if (response.status === 404) return null
    if (!response.ok) throw new Error(`by-host respondeu ${response.status}`)
    return response.json()
  },

  /**
   * Tenant do usuario logado.
   *
   * O painel abre tanto na raiz quanto no endereco da imobiliaria, entao o slug
   * nao pode vir da URL: vem do proprio token, resolvido pelo back-end.
   */
  findCurrent: (): Promise<TenantMeInterface> =>
    Http.get<TenantMeInterface>(`${basePath}/me`, undefined, true)
}

export default TenantService
